import { useContext } from 'react';

import {
  PageContext,
  PageContextValues,
} from '../../context/entity-page-context/entity-page-context';

export const usePageContext = (): PageContextValues => {
  const context = useContext(PageContext);

  if (!context || !context.pageContext) {
    throw new Error('No host context found. Please setup the PageContext');
  }

  return context;
};
